import { Injectable } from '@angular/core';
import { ApiClientService } from '../api-client.service';
import { Observable } from 'rxjs/Observable';
import { IPublicAmenity } from '../../types/api-response/amenity/public-amenity';
import { ApiResponseList } from '../../types/api-response/helpers';
import { IAmenity } from '../../types/api-response/amenity/amenity';
import { IStripeAccount } from '../../types/api-response/stripe-account';
import { IStripePayment } from '../../types/api-response/amenity/stripe-payment';
import { IStripeBalance } from '../../types/api-response/amenity/stripe-balance';
import { IStripePayout } from '../../types/api-response/amenity/stripe-payout';

@Injectable()
export class AmenityApiService {

    constructor(private api: ApiClientService) {}

    /**
     * Returns amenity list
     */
    getAmenityList(params: any = null): Observable<ApiResponseList<IAmenity>> {
        return this.api.getJson('domainAmenities', '/v1/amenity' + ApiClientService.serialize(params));
    }

    /**
     * Returns public amenities list
     *
     * @param corporationNumberId
     * @param amenityIds
     */
    getPublicCorporationAmenities(corporationNumberId: number, amenityIds: number[] = null): Observable<ApiResponseList<IPublicAmenity>> {
        const params = ApiClientService.serialize({
            ids: amenityIds && Array.isArray(amenityIds) ? amenityIds.join(',') : null
        });

        return this.api.getJson('domainAmenities', `/public/amenities/cn_${corporationNumberId}.json${params}`);
    }

    /**
     * Returns stripe payments list
     *
     * @param accountUuid - stripe account uuid
     * @param params
     */
    getStripePayments(accountUuid, params = {}): Observable<ApiResponseList<IStripePayment>> {

        return this.api.getJson('domainAmenities', `/v1/stripe_payments/${accountUuid}.json` + ApiClientService.serialize(params));
    }

    /**
     * Returns stripe payouts details
     *
     * @param params
     */
    getStripePayouts(params = {}): Observable<ApiResponseList<IStripePayout>> {

        return this.api.getJson('domainAmenities', '/v1/stripe_payout.json' + ApiClientService.serialize(params));
    }

    /**
     * Returns balance details
     * for selected stripe account UUID
     *
     * @param accountUuid
     */
    getStripeBalance(accountUuid: string): Observable<ApiResponseList<IStripeBalance>> {
        return this.api.getJson('domainAmenities', `/v1/stripe_balances/${accountUuid}`);
    }

    /**
     * Returns amenity stripe accounts
     */
    getStripeAccounts(): Observable<ApiResponseList<IStripeAccount>> {
        return this.api.getJson('domainAmenities', `/v1/stripe_account`);
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/api/amenity-api.service.ts